module.exports = __webpack_public_path__ + "img/loading.d6a2dfbe.gif";